import React from 'react';
import { Building2, Users, Settings, BarChart3 } from 'lucide-react';

const QuickActions = () => {
  const actions = [
    {
      label: 'View All Gyms',
      description: 'Manage gym locations',
      icon: Building2,
      href: '/admin/gyms',
      color: 'blue'
    },
    {
      label: 'User Management',
      description: 'Manage user accounts',
      icon: Users,
      href: '/admin/users',
      color: 'green'
    },
    {
      label: 'Gym Management',
      description: 'Configure gym settings',
      icon: Settings,
      href: '/admin',
      color: 'purple'
    },
    {
      label: 'Analytics',
      description: 'Detailed usage reports',
      icon: BarChart3,
      href: '#',
      onClick: (e) => {
        e.preventDefault();
        // This will be handled by parent to switch tabs
        const event = new CustomEvent('switchAdminTab', { detail: 'analytics' });
        window.dispatchEvent(event);
      },
      color: 'orange'
    }
  ];

  const colorClasses = {
    blue: {
      bg: 'bg-blue-50',
      hover: 'hover:bg-blue-100',
      icon: 'text-blue-600',
      iconBg: 'bg-blue-100'
    },
    green: {
      bg: 'bg-green-50',
      hover: 'hover:bg-green-100',
      icon: 'text-green-600',
      iconBg: 'bg-green-100'
    },
    purple: {
      bg: 'bg-purple-50',
      hover: 'hover:bg-purple-100',
      icon: 'text-purple-600',
      iconBg: 'bg-purple-100'
    },
    orange: {
      bg: 'bg-orange-50',
      hover: 'hover:bg-orange-100',
      icon: 'text-orange-600',
      iconBg: 'bg-orange-100'
    }
  };

  return (
    <div className="bg-white shadow rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
          Quick Actions
        </h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {actions.map((action) => {
            const Icon = action.icon;
            const colors = colorClasses[action.color];

            return (
              <a
                key={action.label}
                href={action.href}
                onClick={action.onClick}
                className={`${colors.bg} ${colors.hover} rounded-lg p-4 transition-colors duration-150 block`}
              >
                <div className="flex items-start">
                  <div className={`${colors.iconBg} rounded-lg p-2`}>
                    <Icon className={`h-5 w-5 ${colors.icon}`} />
                  </div>
                  <div className="ml-3 flex-1">
                    <p className="text-sm font-medium text-gray-900">
                      {action.label}
                    </p>
                    <p className="text-xs text-gray-600 mt-1">
                      {action.description}
                    </p>
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default QuickActions;
